import { motion } from "framer-motion";
import { Check } from "lucide-react";

const REASONS = [
  { h: "Customised Solutions", p: "Every dashboard built around your actual processes and KPIs." },
  { h: "Simple and Easy to Use", p: "A market woman should understand it. A CEO should respect it." },
  { h: "Executive-Focused", p: "Boardroom-grade reporting designed for decision-making leaders." },
  { h: "Industry Knowledge", p: "Deep experience across 13 industries — from banking to farming." },
  { h: "Scalable", p: "Start with one dashboard, grow into an enterprise-wide system." },
  { h: "Secure", p: "Data handled with governance, access controls and audit trails." },
  { h: "Reliable", p: "Predictable delivery, dependable uptime, and disciplined change management." },
  { h: "Long-Term Support", p: "We stay with you post-launch — training, tuning, and continuous improvement." },
];

export default function OpsWhyChoose() {
  return (
    <section data-testid="section-why-choose" className="relative bg-[#1A2E4A] text-[#F1ECE0] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="mb-14 md:mb-16 max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#D9FF3C] mb-6 inline-flex items-center gap-2">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#D9FF3C]" />
            Why OpsIQ
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Why organisations
            <br />
            <span className="italic">choose OpsIQ.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {REASONS.map(({ h, p }, i) => (
            <motion.div
              key={h}
              data-testid={`reason-${h.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              whileHover={{ y: -4 }}
              className="group border border-white/10 p-6 md:p-7 hover:border-[#D9FF3C] hover:bg-[#142645]/60 transition-colors"
            >
              <div className="h-11 w-11 rounded-full bg-[#D9FF3C]/12 flex items-center justify-center mb-6 group-hover:bg-[#D9FF3C] transition-colors">
                <Check size={20} strokeWidth={2} className="text-[#D9FF3C] group-hover:text-[#142645] transition-colors" />
              </div>
              <h3 className="font-editorial text-2xl leading-tight tracking-tight mb-3">{h}</h3>
              <p className="text-sm text-[#F1ECE0]/70 leading-relaxed">{p}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
